import classNames from 'classnames'
import { t } from 'i18next'
import { SetStateAction, useContext, useEffect, useState } from 'react'
import childPlanFormDataContext from '../../../contexts/ChildPlanFormDataContext'
import ParentFormDataContext from '../../../contexts/ParentFormDataContext'
import { formatCAD } from '../../../utils/currencyFormatHelper'
import ChildSelectedPremiumsTable from '../confirmation/ChildSelectedPremiumsTable'


export interface ITotalCost {
    className?: string
    isModalOpen: boolean
    setShowConfirmation: React.Dispatch<SetStateAction<boolean>>

}

const TotalCost: React.FC<ITotalCost> = ({ className, isModalOpen, setShowConfirmation }) => {
    const { parentFormData, setParentFormData } = useContext(
        ParentFormDataContext
    )

    const { childPlanFormData, setChildPlanFormData } = useContext(
        childPlanFormDataContext
    )
    const [total, setTotal] = useState<number>(0)
    const [isFamily, setIsFamily] = useState<boolean>(false)
    const childPremiums = childPlanFormData.map((child, index) => (
        <ChildSelectedPremiumsTable key={index} childPlan={child} />
    ))

    useEffect(() => {
        let totalTemp = 0
        childPlanFormData.forEach(child => {
            totalTemp += child.Plan.Premium ? child.Plan.Premium : 0;
        })
        setTotal(totalTemp)
    }, [childPlanFormData])

    useEffect(() => {
        setIsFamily(parentFormData.FamilyRate)
    }, [parentFormData.FamilyRate])


    return (
        <div className={classNames(className, isModalOpen ? "blur-lg" : "", " w-full bottom-16 lg:right-5 lg:top-24 lg:w-52 lg:pt-2")}>
            <div className="bg-[#9ccb45] flex flex-col items-center shadow-md">
                <div className="flex flex-col justify-center items-center lg:h-24 h-16">
                    <div className={classNames("lg:grid lg:grid-cols-1 flex flex-row")}>
                        <h1 className="text-center text-black text-xl font-semibold items-center ml-1">
                            {t('totalCost')}&nbsp;
                        </h1>
                        <p className="text-black font-semibold text-xl text-center justify-center ml-1">
                            {formatCAD(total, parentFormData.Language)}&nbsp;
                        </p>
                    </div>
                    {isFamily === true && (
                        <p className="text-black font-semibold text-center lg:text-sm text-base">
                            {t('familyRate')}
                        </p>
                    )}
                </div>
            </div>
        </div>
    )
}

export default TotalCost
